export const BUCKET_COUNT = 10_000;
